import { Component, OnInit, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import {Router } from "@angular/router";
import { AuthService } from "../../login/services/auth.service";
import { DacConfig} from "../../shared/services/dac-config.service";
import { Role } from 'app/shared/models/role';
import { NavBarService } from 'app/theme/services/nav-bar.service';
import { NavBarItem } from 'app/theme/models/nav-bar-item';
import { SidenavComponent } from 'ng-mdb-pro/pro';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'dac-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit, OnDestroy {

  @ViewChild('sidenav')
  private sideNav: SidenavComponent;
  private subscription:Subscription;

  constructor(
    private navBarService:NavBarService
    ,private authService:AuthService
    ,private dacConfig:DacConfig
    ,private router:Router
  ) { }

  ngOnInit() {
    this.subscription = this.navBarService.displaySideBarEvent.subscribe(() => {
        this.sideNav.show();
    });
  }
  ngAfterViewInit() {
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public handleItemClick(navBarItem:NavBarItem, event:Event) {
    if (navBarItem.id === 'logout') {
      this.logout();
      return;
    }
    
    this.navBarService.handleMenuItemClick(navBarItem, event);
  }
  public show() {
    this.sideNav.show();
  }

  public handleNavItemClick(navItem:NavBarItem) {
    if (navItem.id === 'logout') {
      this.logout();
    }
  }

  get navItems() : NavBarItem[] {
    return this.navBarService.navItemsForDisplay;
  }

  get showSidebar() {
    return false;
  }

  get logoUrl() {
    return this.dacConfig.applicationLogoUrl;
  }

  get logoTitle() {
    return this.dacConfig.applicationLogoTitle;
  }

  logout() {
    this.authService.logout().then((resp) => {
      if (resp.redirectUrl) {
        window.location.href = resp.redirectUrl;
      }
      else {
        this.router.navigate(['/home']);
      }
    })
    .catch((error) => {
      console.error(error);
      this.router.navigate(["/home"]);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/sidebar/sidebar.component.ts